const GADS_ID = "AW-18059115940";

/**
 * Push an event (and optional data) onto the dataLayer.
 */
export function pushDataLayer(event: string, data?: Record<string, unknown>): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}

/**
 * Forward consent state to Google Consent Mode v2.
 * The initial default-deny is set synchronously in index.html;
 * this function sends the "update" after the user interacts with the banner.
 */
export function updateConsent(analytics: boolean, marketing: boolean): void {
  window.dataLayer = window.dataLayer || [];

  // Ensure gtag helper exists (defined in index.html)
  if (typeof window.gtag !== "function") {
    window.gtag = function (...args: unknown[]) {
      (window.dataLayer as unknown[]).push(args);
    };
  }

  window.gtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });

  // Configure Google Ads after consent is granted
  if (marketing) {
    window.gtag("config", GADS_ID);
  }

  pushDataLayer("consent_update");
}

// Type augmentation
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    gtag: (...args: unknown[]) => void;
  }
}
